export default __webpack_public_path__ + "static/media/Google__G__Logo.3cec7ff9.svg";